import React from "react";
import { motion } from "framer-motion";

const AdhsDetails = () => {
  return (
    <div className="container my-4 my-md-5 text-center">
      <motion.div
        className="announcement bg-light p-4 p-md-5 rounded shadow"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <img
          src="/images/projekte/adhs/adhss.png"
          alt="Aufmerksamkeitsdefizit-/Hyperaktivitätsstörung"
          className="img-fluid rounded mb-3"
          style={{
            maxHeight: "500px" // Animasyon ekledik
          }}
        />

        <h2 className="fw-semibold text-success mt-4 mb-5 ">
          ADHS ( Aufmerksamkeitsdefizit - /Hyperaktivitätsstörung )
        </h2>

        <div className="mt-5 mb-5 text-start fs-4 d-flex flex-column gap-2 ps-md-3 ps-sm-1">
          <p>💎 Häufige Irrtümer über ADHS!</p>
          <p>💎 Wie erkennt man die Symptome?</p>
          <p>💎 Unterstützungsmethoden zu Hause und in der Schule.</p>
          <p>💎 Wichtige Aspekte der Kommunikation in der Familie.</p>
        </div>

        <div>
          <p className="card-text mt-4 fs-3 text-danger fw-bold">
            🌟Wir freuen uns auf euch am Sonntag, den 7. Dezember!
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default AdhsDetails;
